export function FormInput({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  disabled = false,
}: {
  label: string;
  value: string | number;
  onChange: (v: string) => void;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
}) {
  return (
    <div>
      <label className="block text-xs font-semibold mb-1" style={{ color: "#71717a" }}>
        {label}
      </label>
      <input
        type={type}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-xl px-3 py-2.5 text-sm focus:outline-none transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
        style={{
          backgroundColor: disabled ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.6)",
          border: "1px solid rgba(0,0,0,0.14)",
          color: "#0f0f0f",
        }}
        onFocus={(e) => {
          if (disabled) return;
          e.currentTarget.style.border = "1px solid #111111";
          e.currentTarget.style.boxShadow = "0 0 0 3px rgba(0,0,0,0.10)";
        }}
        onBlur={(e) => {
          e.currentTarget.style.border = "1px solid rgba(0,0,0,0.14)";
          e.currentTarget.style.boxShadow = "none";
        }}
      />
    </div>
  );
}
